import { P, FF } from "../../styles/tokens";
import { MESES } from "../../constants/months";
import { sum } from "../../utils/format";

export default function MonthPicker({ activeMonth, onSelect, onClose, data }) {
  return (
    <div
      aria-label="Seleccionar mes"
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.35)", zIndex: 100, display: "flex", alignItems: "flex-end", backdropFilter: "blur(4px)" }}
      onClick={onClose}
      onKeyDown={(e) => { if (e.key === "Escape") onClose(); }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: P.surface, borderRadius: "28px 28px 0 0", width: "100%", padding: "20px 0 32px", maxHeight: "72vh", overflowY: "auto" }}
      >
        <div style={{ width: 40, height: 4, borderRadius: 99, background: P.border, margin: "0 auto 20px" }} />
        <div style={{ fontSize: 11, fontWeight: 700, color: P.textXs, padding: "0 20px 14px", textTransform: "uppercase", letterSpacing: "0.08em", fontFamily: FF }}>
          Selecciona un mes
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 1, background: P.bg }}>
          {MESES.map((mes, i) => {
            const m = data[i];
            const sav = sum(m.ingresos) - sum(m.fijos) - sum(m.extras);
            const hasData = sum(m.ingresos) > 0 || sum(m.fijos) > 0;
            const isActive = activeMonth === i;
            return (
              <button
                key={i}
                onClick={() => { onSelect(i); onClose(); }}
                style={{
                  background: isActive ? P.ingresos.pastel : P.surface,
                  border: "none", padding: "16px 12px", cursor: "pointer", fontFamily: FF,
                  display: "flex", flexDirection: "column", alignItems: "center", gap: 6,
                }}
              >
                <span style={{ fontSize: 13, fontWeight: isActive ? 700 : 400, color: isActive ? P.ingresos.text : P.textMd }}>
                  {mes}
                </span>
                {hasData && (
                  <div style={{ width: 6, height: 6, borderRadius: "50%", background: sav >= 0 ? P.ingresos.mid : P.danger.mid }} />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
